export default __webpack_public_path__ + "static/media/quick-apply.a870efa5.svg";